import {trpc} from '@common-web/lib/trpc';
import {Skeleton} from '@common-web/components/ui/skeleton';
import {ChangeUserRole} from '../../users/components/ChangeUserRole';

export function ClientUsersSection({clientId, disabled}: {clientId: string; disabled?: boolean}) {
  const utils = trpc.useUtils();

  const usersQuery = trpc.internal.client.listUsers.useQuery({clientId});

  return (
    <div className='border border-gray-200 rounded-lg bg-white p-4 space-y-4'>
      <div className='text-sm font-semibold text-brand-navy'>Tenant users</div>
      {usersQuery.isLoading ? (
        <div className='space-y-2'>
          <Skeleton className='h-10 w-full' />
          <Skeleton className='h-10 w-full' />
          <Skeleton className='h-10 w-full' />
        </div>
      ) : !usersQuery.data || usersQuery.data.length === 0 ? (
        <div className='text-sm text-brand-gray'>No client users on this tenant.</div>
      ) : (
        <div className='space-y-2'>
          {usersQuery.data.map((u) => (
            <div key={u.userId} className='flex items-center gap-3'>
              <div className='flex-1 min-w-0'>
                <div className='text-sm font-medium text-brand-navy truncate'>
                  {u.name ?? u.email}
                </div>
                <div className='text-xs text-brand-gray truncate'>{u.email}</div>
              </div>
              <ChangeUserRole
                userId={u.userId}
                userName={u.name ?? u.email}
                scope='CLIENT'
                clientId={clientId}
                currentRole={u.role}
                disabled={disabled}
                onRoleChanged={() => void utils.internal.client.listUsers.invalidate({clientId})}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
